import { GET_USER_ROLE_SETTINGS } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'

const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getUserRoles = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/roles`, options))
    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500) {
      log.warn('non 200 exit code from roles')
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_USER_ROLE_SETTINGS,
        payload: data
      })
    }
  }
}

export const postUserRole = (roleName, roleDesc, rolePermissions, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { roleName, roleDesc, rolePermissions }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/roles`, options))
    if (!response.status || response.status === 500 || response.status === 401 || response.status === 404 || response.status === 400) {
      fireFailure()
    } else {
      const { data } = response.json
      log.debug(data)
      fireSuccess()
    }
  }
}

export const updateUserRole = (roleID, roleName, roleDesc, rolePermissions, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { roleName, roleDesc, rolePermissions }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/roles/${roleID}`, options))
    if (!response.status || response.status === 500 || response.status === 401 || response.status === 404 || response.status === 400) {
      fireFailure()
    } else {
      const { data } = response.json
      log.debug(data)
      fireSuccess()
    }
  }
}

export const deleteUserRole = (roleID, fireDeleteSuccess, fireDeleteFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const responseDel = await trackPromise(window.fetch(`${api}/accounts/${accountId}/roles/${roleID}`, options))

    if (!responseDel.status || responseDel.status === 401 || responseDel.status === 404 || responseDel.status === 500) {
      fireDeleteFailure()
    } else {
      fireDeleteSuccess()
    }
  }
}
